"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _EventHandler2 = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/event/EventHandler"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * Swiper page observer.
 */
var PageObserver = /*#__PURE__*/function (_EventHandler) {
  _inherits(PageObserver, _EventHandler);

  var _super = _createSuper(PageObserver);

  /**
   * Class constructor.
   *
   * @param {Element} excludeElement Element to exlcude.
   */
  function PageObserver(excludeElement) {
    var _this;

    _classCallCheck(this, PageObserver);

    _this = _super.call(this, {
      supportedEvents: ['change'],
      componentName: 'Swiper'
    });
    _this._observer = null;
    _this._excludeElement = excludeElement;
    return _this;
  }
  /**
   * Connects an observer on the component.
   */


  _createClass(PageObserver, [{
    key: "connect",
    value: function connect() {
      var _this2 = this;

      if (this._observer === null) {
        this._observer = new MutationObserver(function (mutations) {
          if (mutations.length > 0 && (mutations[0].addedNodes.length > 0 || mutations[0].removedNodes.length > 0) && !_this2._excludeElement.contains(mutations[0].target)) {
            clearTimeout(_this2._changeObserverTimeout);
            _this2._changeObserverTimeout = setTimeout(_this2.trigger.bind(_this2, 'change', mutations), 500);
          }
        });

        this._observer.observe(document.body, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });
      }
    }
    /**
     * Disconnects observer on the component.
     */

  }, {
    key: "disconnect",
    value: function disconnect() {
      clearTimeout(this._changeObserverTimeout);

      if (this._observer !== null) {
        this._observer.disconnect();

        this._observer = null;
      }
    }
  }]);

  return PageObserver;
}(_EventHandler2.default);

exports.default = PageObserver;